import qs from 'qs'
import request from 'api/requestUtils'
import type { actions } from '@luxuryescapes/contract-svc-tag'

type GetManyTagsResponse = actions['getManyTags']['responses']['200']['content']['application/json']

export interface GetTagsByDestinationIdParams {
  destinationId: string
  limit?: number
  offset?: number
}

export interface GetTagsByOfferIdParams {
  offerId: string
  limit?: number
  offset?: number
}

export interface Tag {
  id: string
  name: string
  createdAt: string
  updatedAt: string
}

export interface GetTagsResult {
  tags: Array<Tag>
  pagination: {
    limit: number
    offset: number
    total_items: number
    has_next: boolean
    has_previous: boolean
  }
}

/**
 * Retrieves tags assigned to a destination by destination ID
 * @param params - Parameters including destinationId and optional pagination
 * @returns Promise with tags (including names) and pagination info
 */
export function getTagsByDestinationId(
  params: GetTagsByDestinationIdParams,
): Promise<GetTagsResult> {
  const { destinationId, limit, offset } = params

  const query = qs.stringify({
    entityIdIn: [destinationId],
    entityTypeIn: ['DESTINATION'],
    ...(limit !== undefined && { limit }),
    ...(offset !== undefined && { offset }),
  }, {
    arrayFormat: 'brackets',
  })

  return request
    .get<GetManyTagsResponse>(`/api/tags/v1/tags?${query}`, { excludeBrand: true })
    .then((response) => ({
      tags: response.result,
      pagination: response.pagination,
    }))
}

/**
 * Retrieves tags assigned to an offer by offer ID
 * @param params - Parameters including offerId and optional pagination
 * @returns Promise with tags (including names) and pagination info
 */
export function getTagsByOfferId(
  params: GetTagsByOfferIdParams,
): Promise<GetTagsResult> {
  const { offerId, limit, offset } = params

  const query = qs.stringify({
    entityIdIn: [offerId],
    ...(limit !== undefined && { limit }),
    ...(offset !== undefined && { offset }),
  }, {
    arrayFormat: 'brackets',
  })

  return request
    .get<GetManyTagsResponse>(`/api/tags/v1/tags?${query}`, { excludeBrand: true })
    .then((response) => ({
      tags: response.result,
      pagination: response.pagination,
    }))
}
